import { Heading } from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";

export const Github=()=>{
    return(
        <div style={{marginTop:'20px'}}>
        <Heading color={'text'} mb='20px'>My <strong style={{color:'#4FC3F7'}}>GitHub </strong>Calendar</Heading>
        <GitHubCalendar hideTotalCount username="rutuvikp" style={{color:'white', margin:'auto', marginTop:'20px', width:'90%'}}/>
        <Heading color={'text'} mb='20px'>My <strong style={{color:'#4FC3F7'}}>GitHub </strong>Statistics</Heading>
        </div>
    )
};